
export {
  compareSortOrder,
  snapshot2object,
  snapshots2objects,
}

function compareSortOrder( a, b ) {
  if ( a.sortorder < b.sortorder ) {
    return -1
  }
  if ( a.sortorder > b.sortorder ) {
    return 1
  }
  return 0
}

function snapshot2object( snapshot ) {
  const obj = snapshot.val()
  Object.defineProperty( obj, '.key', { value: snapshot.key, enumerable: false } )
  return obj
}

function snapshots2objects( arrayOfSnapshots ) {
  const arrayOfObjects = arrayOfSnapshots.map( snapshot => {
    return snapshot2object( snapshot )
  })
  return arrayOfObjects
}

